module.exports = __webpack_public_path__ + "2b89b766a73911288a181b5f1d040037.png";